import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TimerIcon from '@mui/icons-material/Timer';
import { dateTimeToLocalDate, dateTimeToLocalTime } from '../dateTimeToLocal';
import { useGetSessionQuery } from '../services/api';

export function SessionSchedule({
  guid
}: {
  guid?: string;
}) {
  const { data: session } = useGetSessionQuery(guid);

  return (
    <Grid
      container
      item
      xs={12}
    >
      <Grid
        item
        xs={12}
        md={5}
        display='flex'
        justifyContent='space-between'
        border='solid 1px'
        padding={2}
        alignItems='center'
      >
        <Box
          display='flex'
          alignItems='center'
        >
          <CalendarMonthIcon />
          <Typography
            fontWeight={500}
            lineHeight={1}
          >Start Date</Typography>
        </Box>
        <Typography
        >{session?.startDateTime
          ? dateTimeToLocalDate(session?.startDateTime)
          : (session?.startDay || 'Unscheduled')
          }</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        display='flex'
        justifyContent='space-between'
        border='solid 1px'
        padding={2}
        alignItems='center'
      >
        <Box
          display='flex'
          alignItems='center'
        >
          <ScheduleIcon />
          <Typography
            fontWeight={500}
            lineHeight={1}
          >Start Time</Typography>
        </Box>
        <Typography
        >{dateTimeToLocalTime(session?.startTime ?? session?.startDateTime) || 'TBD'}</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        display='flex'
        justifyContent='space-between'
        border='solid 1px'
        padding={2}
        alignItems='center'
      >
        <Box
          display='flex'
          alignItems='center'
        >
          <TimerIcon />
          <Typography
            fontWeight={500}
            lineHeight={1}
          >Session Length</Typography>
        </Box>
        <Typography
        >{`${session?.duration} Min`}</Typography>
      </Grid>
    </Grid>
  );
}
